import FgInput from "./components/Inputs/FormGroupInput.vue";
import DropDown from "./components/Dropdown.vue";
import Card from "./components/Cards/Card.vue";
import Button from "./components/Button.vue";
import MarqueeText from 'vue-marquee-text-component'
import VuePaycard from "vue-paycard";
import vueLazyload from 'vue-lazyload'
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import { fas } from '@fortawesome/free-solid-svg-icons'
import VueCookies from 'vue-cookies'
// Element Plus components are imported globally in main.js

library.add(fas)
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(app) {
    app.component("drop-down", DropDown);
    app.component("card", Card);
    app.component("n-button", Button);
    // Element Plus components are registered globally in main.js
    app.component("fg-input", FgInput);
    app.component('marquee-text', MarqueeText)
    app.component('font-awesome-icon', FontAwesomeIcon)
    app.use(vueLazyload)
    app.use(VuePaycard);
    app.use(VueCookies, { expires: '5min', secure: true })
  },
};

export default GlobalComponents;
